// extracted by mini-css-extract-plugin
module.exports = {"launchGRDSpecification":"style_launchGRDSpecification__v45p3"};